import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Range, Root as SliderRoot, Thumb, Track } from "@radix-ui/react-slider";
import { useMediaRemote, useMediaState } from "@vidstack/react";
import { useEffect, useState } from "react";
const TimeSlider = () => {
    const time = useMediaState("currentTime");
    const canSeek = useMediaState("canSeek");
    const duration = useMediaState("duration");
    const seeking = useMediaState("seeking");
    const remote = useMediaRemote();
    const step = (1 / duration) * 100;
    const [value, setValue] = useState(0);
    /** Keep slider value in-sync with playback. */
    useEffect(() => {
        if (seeking)
            return;
        setValue((time / duration) * 100);
    }, [time, duration, seeking]);
    return (_jsxs(SliderRoot, { className: "group relative inline-flex h-8 w-full cursor-pointer touch-none select-none items-center outline-none", value: [value], disabled: !canSeek, step: Number.isFinite(step) ? step : 1, onValueChange: ([value]) => {
            setValue(value);
            remote.seek((value / 100) * duration);
        }, onValueCommit: ([value]) => {
            remote.seek((value / 100) * duration);
        }, children: [_jsx(Track, { className: "relative h-[5px] w-full rounded-sm bg-white/30", children: _jsx(Range, { className: "absolute h-full rounded-sm bg-brand bg-media-brand will-change-[width]" }) }), _jsx(Thumb, { "aria-label": "Tempo atual", className: "block h-[15px] w-[15px] rounded-full border border-[#cacaca] bg-white opacity-0 outline-none ring-white/40 transition-opacity will-change-[left] focus:opacity-100 focus:ring-4 group-hocus:opacity-100" })] }));
};
TimeSlider.displayName = "TimeSlider";
export default TimeSlider;
